import { ICardContainer } from "@/components/Card/card.interface";
import CardContainer from "../CardContainer";

export default function PaddedCardContainer({
  children,
  ...rest
}: PaddedCardContainerProps) {
  return (
    <CardContainer sx={{ padding: 3, gap: 2 }} {...rest}>
      {children}
    </CardContainer>
  );
}

type PaddedCardContainerProps = ICardContainer;
